<template>
<v-card color="orange">
  <v-card-title>
    <v-bottom-sheet v-model="sheet">
      <template v-slot:activator>
        <h3>
          {{ dirView.name }}
        </h3>
      </template>
      <v-list>
        <v-subheader>{{$t('dir.what_you_do')}} ?</v-subheader>

        <v-list-tile @click="deleteDir()">
          <v-list-tile-avatar>
            <v-avatar size="32px" tile>
              <v-btn flat @click="$emit('delete', dirView)" color="orange">
                <v-icon fab block color="grey darken-3" style="color: #efefef">delete</v-icon>
              </v-btn>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title>{{$t('dir.delete_folder')}}</v-list-tile-title>
        </v-list-tile>

        <Update :schemas="schemas" v-on:updated="updated($event)" :dirView.sync="dirView">
          <v-list-tile style="margin-top:-1.2rem;margin-bottom:-1.2rem;" slot="activator">
            <v-list-tile-avatar>
              <v-avatar size="32px" tile>
                <v-icon fab block color="grey darken-3" style="color: #efefef">edit</v-icon>
              </v-avatar>
            </v-list-tile-avatar>
            <v-list-tile-title>{{$t('dir.update_folder')}}</v-list-tile-title>
          </v-list-tile>
        </Update>

        <v-spacer></v-spacer>
        <v-list-tile :to="{ name: 'form-view', params: { schemaId: schema.id } }" v-for="schema in dirView.schemas" :key="schema.name" @click="sheet = false">
          <v-list-tile-avatar>
            <v-avatar size="32px" tile>
              <v-icon fab block color="grey darken-3" style="color: #efefef">assignment</v-icon>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title>{{$t('dir.open_schema')}} {{ schema.name }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>


  </v-card-title>
  <v-divider></v-divider>
  <v-list dens>
    <v-list-tile :key="index" v-for="(value,index) in dirView.schemas">
      <v-list-tile-content class="align-start">
        <span style="cursor:pointer;color: #001744"
              @click="$router.push({ name: 'form-view', params: { schemaId: value.id }})">{{ value.name }}
          <v-icon block color="blue darken-3" fab style="color: #efefef;float:right">search</v-icon>
        </span>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
  <v-divider></v-divider>
</v-card>
</template>
<script>
import Update from './Update'

export default {
  components: {
    Update
  },
  props: ['dirView', 'schemas'],
  data() {
    return {
      sheet: false
    }
  },
  methods: {
    updated(dirView) {
      this.$emit("updated", dirView)
    },
    deleteDir() {
      this.$emit('delete', this.dirView)
      this.sheet = false
    }
  }
}
</script>
<style>
</style>
